'use strict';

angular.module('clientDashboardApp').filter('oidToDate', function () {
  return function (text) {
    if (!text.length || text.length < 8) {
      return false;
    }

    let timestamp = parseInt(text.substring(0, 8), 16) * 1000;

    if (isFinite(timestamp)) {
      let date = new Date();
      date.setTime(timestamp);
      return date;
    } else {
      return false;
    }
  }
});
